import { buildNoGroupingGoalListTree } from '@griply/utils';
import { useMemo } from 'react';
import { TreeItem } from 'shared/components/ui/virtualized-tree-list';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type Options = {
  hideArchived?: boolean;
  hideCompleted?: boolean;
};

export const useNoGroupingGoalListTree = (
  goals: Goal[],
  { hideArchived, hideCompleted }: Options,
) =>
  useMemo<Record<ID, TreeItem>>(
    () =>
      buildNoGroupingGoalListTree(goals, {
        hideArchived,
        hideCompleted,
        archivedSectionName: 'Archived',
      }),
    [goals, hideArchived, hideCompleted],
  );
